import { getDelayAction } from 'automaton/actions/DelayAction'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { timings } from 'settings/custom/freespins'

export function getFreespinStartDelayState() {
  const name = 'FS-START-DELAY'
  const actions = [getDelayAction(timings.start)]
  const transition = getFreespinsSpinState

  return {
    name,
    actions,
    transition,
  }
}
